var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"category-info__handler"},[_c('i',{staticClass:"bubble-holder",domProps:{"innerHTML":_vm._s(require(`!!html-loader!@root/assets/svg/bubble-holder.svg`))}}),_vm._v(" "),_c('button',{on:{"click":_vm.scrollToElement}},[_c('fa-icon',{attrs:{"icon":"fa-solid fa-chevron-down bounce"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }